import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Cell } from 'src/app/models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditValueModalComponent } from '../cell-manual-edit/edit-value-modal/edit-value-modal.component';

/**
 * Component used for cell types cella_true_false and cell_edit_true_false
 * in the tables of subtool 4 of NLL
 */

@Component({
    selector: 'app-cell-boolean',
    templateUrl: './cell-boolean.component.html',
    styleUrls: ['./cell-boolean.component.scss'],
    standalone: false
})
export class CellBooleanComponent implements OnInit {

  @Input() data: Cell;
  @Input() cellIndex: number;
  @Input() tableIndex: number;
  @Output() sendSelectedCellValue: EventEmitter<Cell> = new EventEmitter();

  constructor(private modalService: NgbModal) { }

  ngOnInit() { }

  /**
   * Manages the checkbox selection/deselection and send the cell object
   * with the updated value to the parent component
   * @param data Cell selected/deselected
   * @param event Event to be intercepted
   */

  handleChecked(data: Cell, event: Event) {
    event.stopPropagation();
    event.preventDefault();
    data.is_checked = data.is_checked ? false : true;
    this.sendSelectedCellValue.emit(data);
  }

  /**
   * If cell type is cell_edit_true_false, it opens the modal,
   * pass title and subtitle to be displayed in the modal, insert the value in the cell
   * and sends the updated cell to the parent component
   */

  openCellManualEdit() {
    const modalRef = this.modalService.open(EditValueModalComponent, { centered: true, size: '50%' , backdrop: 'static'});
    modalRef.componentInstance.cellValue = this.data.value;
    modalRef.componentInstance.title = 'Define value manually';
    modalRef.componentInstance.inputLabel = 'Insert your value here';
    modalRef.componentInstance.closeModal.subscribe((newValue: string) => {
      this.data.is_edited = true;
      this.data.value = newValue;
      this.data.blocked = true;
      this.sendSelectedCellValue.emit(this.data);
    });
  }
}
